import { Identifiable, ProjectExpenseType } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = {
  _embedded: {
    expenseTypes: Identifiable<ProjectExpenseType>[];
  };
};

function getProjectExpenseTypes(httpClient: HttpClient) {
  return () =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/expenseTypes?page=0&size=9999`,
        method: HttpMethods.GET,
      })
      .then(({ _embedded }) => (_embedded ? _embedded.expenseTypes : []));
}

export { getProjectExpenseTypes };
